export const defaultSettings = {
  softwareName: 'Gym CRM',
  currency: {
    code: 'PKR',
    symbol: 'Rs',
    position: 'before',
    decimalPlaces: 2,
  },
};

export const currencyOptions = [
  { code: 'PKR', symbol: 'Rs', label: 'Pakistani Rupee (PKR)' },
  { code: 'USD', symbol: '$', label: 'US Dollar (USD)' },
  { code: 'CAD', symbol: 'C$', label: 'Canadian Dollar (CAD)' },
  { code: 'AUD', symbol: 'A$', label: 'Australian Dollar (AUD)' },
  { code: 'EUR', symbol: '€', label: 'Euro (EUR)' },
  { code: 'GBP', symbol: '£', label: 'British Pound (GBP)' },
  { code: 'INR', symbol: '₹', label: 'Indian Rupee (INR)' },
  { code: 'AED', symbol: 'د.إ', label: 'UAE Dirham (AED)' },
  { code: 'SAR', symbol: '﷼', label: 'Saudi Riyal (SAR)' },
  { code: 'CHF', symbol: 'CHF', label: 'Swiss Franc (CHF)' },
];
